import { StatusCodes } from '../../core/util/statuscodes';

export class GenericException extends Error
{
    constructor(error: string)
    {
        super(error);
    }

    getStatusCode(): string
    {
        return String(StatusCodes.SUCCESS);
    }

    getStatusMsg(): string
    {
        return this.message;
       //return "";
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/utils/exceptions/genericexception.tsx